export default __webpack_public_path__ + "d18f48d992e6e167f09fe43e713fd34d.svg";